import { Component, OnInit, ViewChild } from '@angular/core';
import { Log, MailLog } from '../../../entities/log.model';
import { ApiService } from '../../../shared/services/api.service';
import { IMyDateRangeModel, IMyDrpOptions } from 'mydaterangepicker';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mail-logs',
  templateUrl: './mail-logs.component.html',
  styles: []
})
export class MailLogsComponent implements OnInit {

  @ViewChild('mailLogsTable') mailLogsTable: DatatableComponent;
  @ViewChild('mailLogModal') private mailLogModal;
  @ViewChild('legacySmsLogModal') private legacySmsLogModal;
  private modalRef: any = null;

  mailLogs: MailLog[];
  allMailLogs: MailLog[];
  tempMailLogs = [];
  loadingIndicator: boolean;
  searchInputSubject = '';
  searchInputMessage = '';
  searchInputRecipient = '';
  searchInputMerchantNumber = '';

  selectedMailLog: MailLog;

  dateRangeOptions: IMyDrpOptions = {
    dayLabels: {su: 'So', mo: 'Mon', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa'},
    monthLabels: { 1: 'Jan', 2: 'Feb', 3: 'Mrz', 4: 'Apr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Okt',
      11: 'Nov', 12: 'Dez' },
    dateFormat: 'dd.mm.yyyy',
    yearSelector: false,
    monthSelector: false,
    selectBeginDateTxt: 'Startdatum auswählen',
    selectEndDateTxt: 'Enddatum auswählen',
    showClearBtn: true,
    showApplyBtn: true,
    openSelectorOnInputClick: true,
    height: '26px',
    width: '239px'
  };

  dateRangeModel: any = {
    beginDate: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date(new Date().setDate(new Date().getDate())).getDate()
    },
    endDate: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate()
    }
  };

  constructor(private apiService: ApiService,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.getLogs();
  }

  getLogs() {
    this.apiService.find<Log>(Log, 'logs-by-source/de_marktgilde_marketmanager_web_rest_MailResource')
      .subscribe(logs => {
        this.loadingIndicator = false;
        this.mailLogs = logs.map<MailLog>(log => new MailLog(log));
        this.allMailLogs = logs.map<MailLog>(log => new MailLog(log));
        this.tempMailLogs = [...this.mailLogs];

        const smallestCreated = new Date(Math.min(...this.mailLogs.map(mailLog => new Date(mailLog.created).getTime())));
        const greatestCreated = new Date(Math.max(...this.mailLogs.map(mailLog => new Date(mailLog.created).getTime())));
        if (logs.length > 0) {
          this.dateRangeModel = {
            beginDate: {
              year: smallestCreated.getFullYear(),
              month: smallestCreated.getMonth() + 1,
              day: smallestCreated.getDate()
            },
            endDate: {
              year: greatestCreated.getFullYear(),
              month: greatestCreated.getMonth() + 1,
              day: greatestCreated.getDate()
            }
          };
        }

      }, err => {
        this.loadingIndicator = false;
        this.mailLogs = [];
      });
  }

  onDateRangeChanged(event: IMyDateRangeModel) {
    console.log('event', event);
    this.dateRangeModel = {
      beginDate: {
        year: event.beginDate.year,
        month: event.beginDate.month,
        day: event.beginDate.day
      },
      endDate: {
        year: event.endDate.year,
        month: event.endDate.month,
        day: event.endDate.day
      }
    };
    this.filterMailLogs();
  }

  filterMailLogs() {
    this.searchInputSubject = '';
    this.searchInputMessage = '';
    this.searchInputRecipient = '';

    this.mailLogs = this.allMailLogs ?
      this.allMailLogs.filter((mailLog, index) => {
        const mailLogDate = new Date(mailLog.created);
        const beginDate = new Date(this.dateRangeModel.beginDate.year, this.dateRangeModel.beginDate.month - 1,
          this.dateRangeModel.beginDate.day);
        const endDate = new Date(this.dateRangeModel.endDate.year, this.dateRangeModel.endDate.month - 1,
          this.dateRangeModel.endDate.day, 23, 59, 59, 999);
        return mailLogDate >= beginDate && mailLogDate <= endDate;
      }) : [];

    this.tempMailLogs = [...this.mailLogs];
    this.mailLogsTable.offset = 0;
  }

  updateSearch(event, field = null) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.tempMailLogs.filter((mailLog: MailLog) => {
      if (field) {
        return ((mailLog[field]) ? mailLog[field].toLowerCase().indexOf(val) !== -1 : !val);
      } else {
        return ((mailLog.message) ? mailLog.message.toLowerCase().indexOf(val) !== -1 : false) ||
          ((mailLog.recipient) ? mailLog.recipient.toLowerCase().indexOf(val) !== -1 : false) ||
          ((mailLog.content) ? mailLog.content.indexOf(val) !== -1 : false) || !val;
      }
    });

    // update the rows
    this.mailLogs = temp;
    // Whenever the filter changes, always go back to the first page
    this.mailLogsTable.offset = 0;
  }

  onActivate(event: any) {
    if (event.type === 'click') {
      event.cellElement.blur();
    }
  }

  onSelect(event: any) {
    this.selectedMailLog = event.selected[0];
    if (this.selectedMailLog.content.startsWith('Recipient')) {
      this.openModal(this.legacySmsLogModal, {size: 'sm', windowClass: 'l'});
    } else {
      this.openModal(this.mailLogModal, {size: 'sm', windowClass: 'l'});
    }
  }

  openModal(modal: any, options: NgbModalOptions) {
    this.modalRef = this.modalService.open(modal, options);
  }

  getSubjectFromContent(content: string): string {
    const subject = content.split('Subject: ')[1];
    return subject ? subject.split('\n')[0] : '';
  }

  getMessageFromContent(content: string): string {
    const message = content.split('Content:\n')[1];
    return message ? message.split('\n')[0] : '';
  }

}



// WEBPACK FOOTER //
// ./src/app/logs/components/mail-logs/mail-logs.component.ts